import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {EmailSummaryFieldComponent} from "./email-summary-field.component";
import {SummaryFieldModule} from "../../../../core/component/summary-field/summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        SummaryFieldModule,
    ],
    declarations: [
        EmailSummaryFieldComponent,
    ],
    exports: [
        EmailSummaryFieldComponent,
    ],
})
export class EmailSummaryFieldModule {
}